import { InstructionsBoard } from "./InstructionsBoard";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { InstructionsContainer } from "./InstructionsContainer";
import { SplashState } from "../SplashState";
import { AudioManager } from "../../AudioManager";

export class HelpLayer extends Phaser.Group {

    public static currentInstance: HelpLayer = null;
    public static currentPage: number;

    private currentBoard: InstructionsBoard;

    constructor(game: Phaser.Game) {

        super(game, null, "help-layer");

        HelpLayer.currentInstance = this;
        HelpLayer.currentPage = 1;

        const backgroundImage = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "texture_atlas_1", "bg.png");
        backgroundImage.anchor.set(.5);
        backgroundImage.scale.set(2, 2 * GameVars.scaleY);
        backgroundImage.inputEnabled = true;
        backgroundImage.events.onInputDown.add(this.onClickBackground, this);
        this.add(backgroundImage);

        const tab = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "menu_tab.png");
        tab.scale.y = GameVars.scaleY;
        this.add(tab);

        const titleLabel = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, 15 * GameVars.scaleY, "HELP", { font: "52px Roboto Slab Regular", fill: "#1b2d3d", align: "center"}); 
        titleLabel.scale.y = GameVars.scaleY;
        titleLabel.anchor.x = .5;
        this.add(titleLabel);

        const buttonHome = new Phaser.Button(this.game, 45, 45 * GameVars.scaleY, "texture_atlas_1", this.onClickHome, this);
        buttonHome.setFrames("button_home_on.png", "button_home_off.png", "button_home_on.png");
        buttonHome.forceOut = true;
        buttonHome.anchor.set(.5);
        buttonHome.scale.y = GameVars.scaleY;
        this.add(buttonHome);

        this.currentBoard = new InstructionsBoard(this.game);
        this.add(this.currentBoard);

        const instructionsContainer: InstructionsContainer = new InstructionsContainer(this.game);
        this.add(instructionsContainer);
    }

    public destroy(): void {

        HelpLayer.currentInstance = null;

        super.destroy();
    }

    public pageChanged(): void {

        this.currentBoard.destroy();

        this.currentBoard = new InstructionsBoard(this.game);
        this.add(this.currentBoard);
    }

    private onClickHome(b: Phaser.Button): void {

        b.clearFrames();

        SplashState.currentInstance.removeHelpLayer();

        AudioManager.playSound("click"); 
    }

    private onClickBackground(): void {
        //
    }
}
